import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";

import Swal from "sweetalert2";

const BackgroundMusicList = (props) => {
    const [backgroundSongs, setBackgroundSongs] = useState([]);
    const [backgroundSongsToShow, setBackgroundSongsToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const responseGet = await api.get("/background-music");

        setBackgroundSongs(responseGet.data.data);
        setBackgroundSongsToShow(responseGet.data.data);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalItems = backgroundSongs;

        if (searchText === "") {
            setBackgroundSongsToShow(originalItems);
            setLoaded(true);
            return;
        }

        let filteredItems = originalItems.filter(
            (item) =>
                item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        );

        setBackgroundSongsToShow(filteredItems);
        setLoaded(true);
    }

    async function handleDelete(itemDelete) {
        Swal.fire({
            title: `Tem certeza que deseja excluir a música ${itemDelete.name}?`,
            text: "Não será possível voltar atrás!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero excluir!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (!result.value) {
                Swal.fire(
                    "Cancelado!",
                    "Nenhum dado será excluído.",
                    "success"
                );
            } else {
                setLoaded(false);

                try {
                    const responseDelete = await api.delete(
                        `/background-music/${itemDelete._id}`
                    );

                    if (responseDelete.status === 204) {
                        const newItems = backgroundSongs.filter(
                            (item) => item._id !== itemDelete._id
                        );
                        setBackgroundSongs(newItems);
                        setBackgroundSongsToShow(newItems);
                        setLoaded(true);
                    } else {
                        throw new Error("Erro ao deletar");
                    }
                } catch (error) {
                    console.log(error);
                    setLoaded(true);
                    Swal.fire({
                        type: "error",
                        title: "Oops...",
                        text: "Tivemos um problema ao excluir essa música. Contate o suporte!",
                    });
                }
            }
        });
    }

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Músicas de Fundo (Se vira nos 30)"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Lista de Músicas de Fundo (Se vira nos 30)
                            </div>
                            <ul className="card-action">
                                <li>
                                    <Link
                                        to="/musicas-fundo/nova"
                                        className="btn btn-sm btn-success"
                                    >
                                        Novo <i className="fa fa-plus"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {backgroundSongsToShow.map(
                                                (item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                <div className="col-xs-12">
                                                                    <div className="col-xs-12">
                                                                        <button
                                                                            className="btn btn-xs btn-danger"
                                                                            style={{
                                                                                width: "100%",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleDelete(
                                                                                    item
                                                                                )
                                                                            }
                                                                        >
                                                                            Excluir
                                                                            <div className="icon fa fa-trash-o"></div>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(BackgroundMusicList);
